import { useFlags } from "launchdarkly-react-client-sdk";

import {
  INBOX_V2_FEATURE,
  UNANSWERED_TEXTS_FEATURE
} from "constants/feature-flags";

/**
 * Whether the Inbox tracks "waiting for a reply" (ENG-2223): the Unanswered Texts flag AND
 * Inbox V2 (the tab, the panel and Done live only there). Nothing about routing: the backend
 * records the wait for every practice, whether or not a clinic has an inbox owner. The ONE
 * place the two are combined — the route, the layout, the action bar, the thread header's Done
 * and the quick launcher all read this, so none of them can disagree on whether
 * `/inbox/needs-reply` is a page or a redirect.
 */
export const resolveNeedsReplyEnabled = (
  unansweredTextsValue: unknown,
  inboxV2Value: unknown
): boolean => Boolean(unansweredTextsValue) && Boolean(inboxV2Value);

export default function useNeedsReplyEnabled(): boolean {
  const flags = useFlags();
  return resolveNeedsReplyEnabled(
    flags[UNANSWERED_TEXTS_FEATURE],
    flags[INBOX_V2_FEATURE]
  );
}
